import React, { Component } from "react";
import styled from "styled-components";
import connect from "../data/redux/connect";
import transformMarkdown from "../../util/markdown";
import colors from "../../../styles/colors";

const ResultContainer = styled.div`
  display: block;
  padding: 10px 0;
  width: 100%;
  > div {
    margin: 10px 0;
  }
`;

const Latin = styled.span`
  font-size: 17.6px;
  color: ${colors.accent};
  letter-spacing: 2px;
  -webkit-font-variant-ligatures: no-common-ligatures;
`;

const Info = styled.span`
  color: ${colors.main};
  text-transform: uppercase;
  font-size: 11.2px;
  letter-spacing: 0.5px;
`;

const Definitions = styled.div`
  color: ${colors.header};
  font-size: 14.4px;
  > div {
    line-height: 1.7;
  }
`;

const mapDefinitions = defs =>
  defs.map((def, i) => {
    return (
      <div
        dangerouslySetInnerHTML={{
          __html: `${
            defs.length < 2 ? "" : ++i + ".&nbsp;"
          } ${transformMarkdown(def)}`
        }}
        key={i}
      />
    );
  });

class Result extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { chapter, definitions, info, latin } = this.props.word;
    return (
      <ResultContainer>
        <div>
          <Latin>{latin + " "}</Latin>
          <Info>{info}</Info>
        </div>

        <Definitions>{mapDefinitions(definitions)}</Definitions>
      </ResultContainer>
    );
  }
}

export default connect(Result);



// WEBPACK FOOTER //
// ./src/apps/vocabularium/components/Result.js